export const IMAGE_UPLOAD_PLACEHOLDER =
  'https://firebasestorage.googleapis.com/v0/b/chicsa-dev/o/Utils%2FuploadImage.png?alt=media&token=0adf170e-6a40-4643-be77-d571303730f1';

export const IMAGE_PLACEHOLDER =
  'https://firebasestorage.googleapis.com/v0/b/chicsa-dev/o/Utils%2Fplaceholder.jpg?alt=media&token=3dcae128-6b40-411a-8439-8d25b0aa608d';

export const IMAGE_NO_DATA =
  'https://firebasestorage.googleapis.com/v0/b/chicsa-dev/o/noData.svg?alt=media&token=225039d3-9ee4-427a-82a4-246e43a75cdc';
